import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import '@/styles/common.less'
Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.$axios = axios
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
new Vue({
  render: h => h(App), router, i18n,
}).$mount('#app')